<template>
  <div class="container-login">
    <div class="background"></div>
    <div class="form-container">
      <div class="form">
        <div class="icon-container">
          <div class="logo">
            <img src="@/assets/logo2.png" alt="Logo" />
          </div>
        </div>
        <div class="text-container">
          <h1>¡Hola de nuevo!</h1>
          <p>Ingresa tus datos para acceder a tu cuenta.</p>
        </div>
        <form method="POST" @submit.prevent="login()" class="form-fields">
          <div class="input-group">
            <label for="email">Correo electrónico</label>
            <input
              v-model="user.email"
              type="email"
              id="email"
              placeholder="Ingresa tu correo electrónico"
              required
            />
          </div>
          <div class="input-group">
            <label for="password">Contraseña</label>
            <input
              v-model="user.password"
              type="password"
              id="password"
              placeholder="••••••••"
              required
            />
            <a @click="toRecoverPassword()" class="text-muted"
              >Obtener nueva contraseña</a
            >
          </div>
          <button type="submit" class="submit-btn">Iniciar sesión</button>
          <div class="divider">
            <div class="line"></div>
            <span>O continuar con</span>
          </div>
          <button type="button" @click="loginGoogle()" class="google-btn">
            <svg class="google-icon" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              ></path>
              <path
                fill="currentColor"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              ></path>
              <path
                fill="currentColor"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              ></path>
              <path
                fill="currentColor"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              ></path>
            </svg>
            Iniciar sesión con Google
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";

export default {
  data() {
    return {
      user: {},
      validRoles: [
        "admin",
        "cliente",
        "liderl",
        "lider",
        "frs",
        "ghumana",
        "free",
      ],
    };
  },
  methods: {
    async login() {
      let data;
      let token;
      let response;
      if (this.user.email && this.user.password) {
        try {
          data = await this.$auth.login(this.user.email, this.user.password);
          token = await data.user.getIdToken();
          response = await apiServices.get(`/usermg/${data.user.uid}`, {
            headers: { Authorization: "Bearer " + token },
          });
          if (response.data) {
            localStorage.setItem("loggedin", "true");
            this.$store.dispatch("notify", {
              message: `Hola ${
                data.user.displayName ? data.user.displayName : "Usuario"
              }`,
              duration: 5000,
            });
          } else {
            this.$auth.logout();

            // firebase.auth().signOut();
            // data.user.delete();
            this.$store.dispatch("notify", {
              message: "Lo sentimos, no tienes permisos de ingreso.",
              type: "is-danger",
              position: "top-center",
            });
          }
        } catch (error) {
          console.log(error);
          if (error.code === "auth/user-not-found") {
            this.$store.dispatch("notify", {
              message: "Lo sentimos, no tienes permisos de ingreso.",
              type: "is-danger",
              position: "top-center",
              duration: 5000,
            });
          } else if (error.code === "auth/wrong-password") {
            this.$store.dispatch("notify", {
              message: "Contraseña incorrecta",
              type: "is-danger",
              position: "top-center",
            });
          } else {
            this.$store.dispatch("notify", {
              message:
                "Ocurrio un error. Contactenos a soportecontable@yungol.com",
              type: "is-danger",
              position: "top-center",
              duration: 5000,
            });
          }
        }
      } else {
        this.$store.dispatch("notify", {
          message: "Ambos campos deben tener información.",
          type: "is-danger",
          position: "top-center",
          duration: 5000,
        });
      }
    },
    async loginGoogle() {
      let data;
      let token;
      let response;
      let empresa;
      try {
        data = await this.$auth.loginGoogle();
        this.$store.commit("loading");
        token = await data.user.getIdToken();
        this.$store.commit("decodeToken", token);

        if (this.checkRoles(this.validRoles, this.$store.state.tokenUser)) {
          response = await apiServices.get(`/usermg/${data.user.uid}`, {
            headers: { Authorization: "Bearer " + token },
          });
          if (response.data) {
            localStorage.setItem("loggedin", "true");
            empresa = await apiServices.get(`/empresacredential`, {
              headers: { Authorization: "Bearer " + token },
            });
            this.$store.commit("refreshEmpresa", empresa.data);
            this.cancelLoading(this);
            this.$store.dispatch("notify", {
              message: `Hola ${
                data.user.displayName ? data.user.displayName : "Usuario"
              }`,
            });
          } else {
            this.$auth.logout();
            // firebase.auth().signOut();
            // data.user.delete();
            this.$store.dispatch("notify", {
              message: "Lo sentimos, no tienes permisos de ingreso.",
              type: "is-danger",
              position: "top-center",
              duration: 5000,
            });
            this.cancelLoading(this);
          }
        } else {
          this.$auth.logout();
          // firebase.auth().signOut();
          // data.user.delete();
          this.$store.dispatch("notify", {
            message: "Lo sentimos, no tienes permisos de ingreso.",
            type: "is-danger",
            position: "top-center",
            duration: 5000,
          });
          this.cancelLoading(this);
        }
      } catch (error) {
        console.log(error);
        this.$store.commit("loading", false);
        if (error.code === "auth/popup-closed-by-user") {
          return this.$store.dispatch("notify", {
            message: "Inicio de sesión de Google cancelado",
            type: "is-white",
            position: "top-center",
            duration: 5000,
          });
        }
        this.$store.dispatch("notify", {
          message: "Ocurrio un error. Contactenos a soportecontable@yungol.com",
          type: "is-danger",
          position: "top-center",
          duration: 5000,
        });
      }
    },
    checkRoles(roles, user) {
      return roles.some((role) => role in user);
    },
    cancelLoading(_this) {
      setTimeout(function() {
        _this.$store.commit("loading", false);
      }, 1500);
    },
    toRecoverPassword() {
      this.$emit("switchForget");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/core/Auth/SignIn.vue